import { FC } from 'react';

export interface TABLE_CONSTANT_RETURN_TYPE {
  id?: string;
  isColumnVisible: boolean;
  title: string;
  render?: (rowData) => JSX.Element | string | null;
}

export interface FILTER_CONSTANT_RETURN_TYPE {
  type: string;
  name: string;
  options?: Array<any>;
  handleSelect?: CallableFunction;
  handleInput?: CallableFunction;
  value?: string;
  label?: string;
  onChange?: CallableFunction;
  inputErrorMessage?: string;
  inputError?: boolean;
  handleInputBlur?: CallableFunction;
  wrapperClass?: string;
}

export interface DateRangeType {
  startDate: string | Date;
  endDate: string | Date;
  key: string;
}

export type permissionEnum =
  | 'VIEW_DATA_ONLY'
  | 'UPDATE_GATEWAY_CONFIG'
  | 'CREATE_REFUND'
  | 'CREATE_GATEWAY'
  | 'CREATE_USER'
  | 'CREATE_ROLE'
  | 'ACTIVATION_DEACTIVATION_ON_GATEWAYS'
  | 'CREATE_ROUTES'
  | 'UPDATE_DELETE_USER'
  | 'VERIFY_IMEI'
  | 'UPDATE_DELETE_PREFERENCE_ROUTES'
  | 'UPDATE_PREFERENCE_PRIORITY_LOGIC'
  | 'UPDATE_DELETE_CUSTOM_ROUTING_LOGIC'
  | 'UPDATE_GENERAL_SETTINGS_DATA'
  | 'UPDATE_WEBHOOK_SETTINGS_DATA'
  | 'UPDATE_CHECKOUT_THEME_SETTINGS_DATA'
  | 'CREATE_ADMIN_USER'
  | 'CREATE_ADMIN_ROLE'
  | 'UPDATE_DELETE_CUSTOM_ROUTE_ADMIN'
  | 'VIEW_GATEWAY_CONFIG'
  | 'VIEW_CREDENTIALS'
  | 'CREATE_PAYMENT_LINKS'
  | 'APPROVE_REJECT_BENEFICIARIES'
  | 'CREATE_BENEFICIARIES'
  | 'APPROVE_REJECT_PAYOUTS'
  | 'CREATE_PAYOUTS'
  | 'CREATE_INDIVIDUAL_PAYOUT'
  | 'CREATE_BULK_PAYOUT'
  | 'CUSTOMIZE_PAYMENT_LINKS'
  | 'EDGE_CUSTOMIZE_PAYMENT_LINK'
  | 'MANAGE_PAYMENT_LINK'
  | 'VIEW_OFFERS'
  | 'CREATE_OFFERS'
  | 'GET_MPR'
  | 'MODIFY_OFFERS'
  | 'VIEW_BULK_REFUND'
  | 'VIEW_BULK_IMEI'
  | 'CREATE_BULK_REFUND'
  | 'CREATE_BULK_IMEI'
  | 'VIEW_OPS_PORTAL'
  | 'MIGRATE_CHECKOUT_MERCHANTS'
  | 'UPDATE_DELETE_ADMIN_USER'
  | 'CREATE_PARTNER_ROLE'
  | 'CREATE_PARTNER_USER'
  | 'GENERATE_REPORTS'
  | 'GENERATE_PARTNER_REPORTS'
  | 'TAKE_ACTION_ON_DISPUTES'
  | 'FORCE_REFUND_MAKER'
  | 'FORCE_REFUND_CHECKER'
  | 'FORCE_UPDATE_ORDER_MAKER'
  | 'FORCE_UPDATE_ORDER_CHECKER'
  | 'CONVENIENCE_FEE_MAKER'
  | 'CONVENIENCE_FEE_CHECKER'
  | 'PAYPREDICT_CHECKER'
  | 'PAYPREDICT_MAKER'
  | 'OBSERVABILITY READ'
  | 'UPDATE_KNOWLEDGE_BASE';

export type routeConfigLayout =
  | 'admin'
  | 'merchant'
  | 'public'
  | 'merchant-payout'
  | 'merchant-payment-link'
  | 'profile'
  | 'common-layout'
  | 'edge-merchant-payment-link'
  | 'partner-layout'
  | 'edge-private' //for Edge specific routes
  | 'complete-profile'
  | 'merchant-subscription'
  | 'public-self-serve-profile'; 
export interface routeConfigType {
  path: string;
  component: FC<any>;
  key: string;
  allowedPermission?: Array<permissionEnum>;
  exact?: boolean;
  layout: routeConfigLayout;
}

export interface reduxStateType {
  isSuccess: boolean;
  isLoading: boolean;
  isFailure: boolean;
  errorCode: string | number;
  data: any;
  errorMessage: string;
  responseCode: string | number;
  responseMessage: string | number;
}
export interface CleverTapEventConfig {
  eventName: string;
  eventPayload?: { [property: string]: string } | any;
}

export enum CleverTapEventConfigName {
  SIGN_UP_EXITED_SIGN_IN = 'SIGN_UP_EXITED_SIGN_IN',
  SIGN_UP_EXITED_CREATE_ACCOUNT = 'SIGN_UP_EXITED_CREATE_ACCOUNT',
  SIGN_UP_SHOWN = 'SIGN_UP_SHOWN',
  LOGIN_SHOWN = 'LOGIN_SHOWN',
  LOGIN_PAGE_EXITED_SIGN_UP = 'LOGIN_PAGE_EXITED_SIGN_UP',
  LOGIN_PAGE_EXITED_FORGOT_PASSWORD = 'LOGIN_PAGE_EXITED_FORGOT_PASSWORD',
  LOGIN_PAGE_EXITED_CONTINUE = 'LOGIN_PAGE_EXITED_CONTINUE',
  RESET_PASSWORD_SHOWN = 'RESET_PASSWORD_SHOWN',
  RESET_PASSWORD_EXITED_CANCEL = 'RESET_PASSWORD_EXITED_CANCEL',
  RESET_PASSWORD_EXITED_SEND_OTP = 'RESET_PASSWORD_EXITED_SEND_OTP',
  OVERVIEW_PAGE_SHOWN = 'OVERVIEW_PAGE_SHOWN',
  SIDEBAR_TAB_CLICKED_REPORTS = 'SIDEBAR_TAB_CLICKED_REPORTS',
  SIDEBAR_TAB_CLICKED_MERCHANT_REPORTS = 'SIDEBAR_TAB_CLICKED_MERCHANT_REPORTS',
  SIDEBAR_TAB_CLICKED_PAYMENT = 'SIDEBAR_TAB_CLICKED_PAYMENT',
  SIDEBAR_TAB_CLICKED_REFUNDS = 'SIDEBAR_TAB_CLICKED_REFUNDS',
  SIDEBAR_TAB_CLICKED_SETTLEMENTS = 'SIDEBAR_TAB_CLICKED_SETTLEMENTS',
  SIDEBAR_TAB_CLICKED_DISPUTES = 'SIDEBAR_TAB_CLICKED_DISPUTES',
  SIDEBAR_TAB_CLICKED_SMART_ROUTING = 'SIDEBAR_TAB_CLICKED_SMART_ROUTING',
  SIDEBAR_TAB_CLICKED_OFFERS = 'SIDEBAR_TAB_CLICKED_OFFERS',
  SIDEBAR_TAB_CLICKED_PAYMENT_LINKS = 'SIDEBAR_TAB_CLICKED_PAYMENT_LINKS',
  SIDEBAR_TAB_CLICKED_PAYMENT_PAGES = 'SIDEBAR_TAB_CLICKED_PAYMENT_PAGES',
  SIDEBAR_TAB_CLICKED_PLANS = 'SIDEBAR_TAB_CLICKED_PLANS',
  SIDEBAR_TAB_CLICKED_SUBSCRIPTIONS = 'SIDEBAR_TAB_CLICKED_SUBSCRIPTIONS',
  SIDEBAR_TAB_CLICKED_ANALYTICS = 'SIDEBAR_TAB_CLICKED_ANALYTICS',
  SIDEBAR_TAB_CLICKED_SETTINGS = 'SIDEBAR_TAB_CLICKED_SETTINGS',
  CONTACT_SUPPORT_SHOWN = 'CONTACT_SUPPORT_SHOWN',
  CONTACT_SUPPORT_EXITED_CLOSE = 'CONTACT_SUPPORT_EXITED_CLOSE',
  CONTACT_SUPPORT_MAIL_ID_CLICKED = 'CONTACT_SUPPORT_MAIL_ID_CLICKED',
  DOCUMENTATION_CLICKED = 'DOCUMENTATION_CLICKED',
  USER_MANAGEMENT_CLICKED_PROFILE = 'USER_MANAGEMENT_CLICKED_PROFILE',
  USER_MANAGEMENT_CLICKED_SETTINGS = 'USER_MANAGEMENT_CLICKED_SETTINGS',
  USER_MANAGEMENT_ROLE_CREATED = 'USER_MANAGEMENT_ROLE_CREATED',
  USER_MANAGEMENT_USER_CREATED = 'USER_MANAGEMENT_USER_CREATED',
  GENERAL_SETTINGS_URL_CHANGED = 'GENERAL_SETTINGS_URL_CHANGED',
  CHECKOUT_SETTINGS_THEME_CHANGED = 'CHECKOUT_SETTINGS_THEME_CHANGED',
  SETTINGS_CREDENTIALS_SHOWN = 'SETTINGS_CREDENTIALS_SHOWN',
  SETTINGS_CREDENTIALS_COPIED_MID = 'SETTINGS_CREDENTIALS_COPIED_MID',
  SETTINGS_CREDENTIALS_COPIED_ACCESS_CODE = 'SETTINGS_CREDENTIALS_COPIED_ACCESS_CODE',
  SETTINGS_CREDENTIALS_COPIED_SECRET_KEY = 'SETTINGS_CREDENTIALS_COPIED_SECRET_KEY',
  SETTINGS_WEBHOOK_URL_CHANGED = 'SETTINGS_WEBHOOK_URL_CHANGED',
  PAYMENT_PAGES_REDIRECTED = 'PAYMENT_PAGES_REDIRECTED',
  PAYMENT_LINKS_BULK_UPLOAD_HISTORY_VIEWED = 'PAYMENT_LINKS_BULK_UPLOAD_HISTORY_VIEWED',
  PAYMENT_LINKS_REPORT_DOWNLOADED = 'PAYMENT_LINKS_REPORT_DOWNLOADED',
  PAYMENT_LINK_CREATED_BULK = 'PAYMENT_LINK_CREATED_BULK',
  PAYMENT_LINK_CREATED_INDIVIDUAL = 'PAYMENT_LINK_CREATED_INDIVIDUAL',
  SMART_ROUTING_GATEWAY_CREATED = 'SMART_ROUTING_GATEWAY_CREATED',
  SMART_ROUTING_FAQ_SHOWN = 'SMART_ROUTING_FAQ_SHOWN',
  SMART_ROUTING_PREFERENCE_SCORE_BIN_ROUTING_UPDATED = 'SMART_ROUTING_PREFERENCE_SCORE_BIN_ROUTING_UPDATED',
  SMART_ROUTING_PREFERENCE_SCORE_ISSUER_ROUTING_UPDATED = 'SMART_ROUTING_PREFERENCE_SCORE_ISSUER_ROUTING_UPDATED',
  SMART_ROUTING_PREFERENCE_SCORE_CARD_BRAND_ROUTING_UPDATED = 'SMART_ROUTING_PREFERENCE_SCORE_CARD_BRAND_ROUTING_UPDATED',
  SMART_ROUTING_PRIORITY_LOGIC_UPDATED = 'SMART_ROUTING_PRIORITY_LOGIC_UPDATED',
  SMART_ROUTING_CUSTOM_ROUTING_LOGIC_TURNED_ON = 'SMART_ROUTING_CUSTOM_ROUTING_LOGIC_TURNED_ON',
  SMART_ROUTING_CUSTOM_ROUTING_LOGIC_TURNED_OFF = 'SMART_ROUTING_CUSTOM_ROUTING_LOGIC_TURNED_OFF',
  REFUND_BULK_UPLOAD_HISTORY_SHOWN = 'REFUND_BULK_UPLOAD_HISTORY_SHOWN',
  REFUND_BULK_UPLOAD_SUCCESS = 'REFUND_BULK_UPLOAD_SUCCESS',
  REFUND_REPORT_DOWNLOADED = 'REFUND_REPORT_DOWNLOADED',
  PAYMENT_REPORT_DOWNLOADED = 'PAYMENT_REPORT_DOWNLOADED',
  OFFERS_REPORT_DOWNLOADED = 'OFFERS_REPORT_DOWNLOADED',
  OVERVIEW_REPORT_DOWNLOADED = 'OVERVIEW_REPORT_DOWNLOADED',
  LOGIN_OTP_PAGE_SHOWN = 'LOGIN_OTP_PAGE_SHOWN',
  LOGIN_OTP_SUBMITTED = 'LOGIN_OTP_SUBMITTED',
  LOGIN_OTP_ERROR_MESSAGE_SHOWN = 'LOGIN_OTP_ERROR_MESSAGE_SHOWN',
  LOGIN_OTP_RESENT = 'LOGIN_OTP_RESENT',
  INCOMPATIBLE_DEVICE_DIALOG_SHOWN = 'INCOMPATIBLE_DEVICE_DIALOG_SHOWN',
  IMEI_BULK_UPLOAD_HISTORY_SHOWN = 'IMEI_BULK_UPLOAD_HISTORY_SHOWN',
  PAN_ENTRY_SCREEN_VIEWED = 'PAN_ENTRY_SCREEN_VIEWED',
  PAN_ENTERED = 'PAN_ENTERED',
  BPCL_BANK_DETAILS_VIEWED = 'BPCL_BANK_DETAILS_VIEWED',
  BPCL_BANK_DETAILS_UPDATED = 'BPCL_BANK_DETAILS_UPDATED',
  BPCL_BANK_DETAILS_APPROVED = 'BPCL_BANK_DETAILS_APPROVED',
  BPCL_BANK_DETAILS_REJECTED = 'BPCL_BANK_DETAILS_REJECTED',
  BPCL_BANK_DETAILS_SUBMITTED = 'BPCL_BANK_DETAILS_SUBMITTED',
  MERCHANT_TAKE_ACTION_CLICKED = 'MERCHANT_TAKE_ACTION_CLICKED',
  BULK_UPLOAD_HISTORY_CLICKED = 'BULK_UPLOAD_HISTORY_CLICKED',
  BULK_ONBOARDING_CLICKED = 'BULK_ONBOARDING_CLICKED',
  DOWNLOAD_CLICKED = 'DOWNLOAD_CLICKED',
  WALLET_CREATE_SCREEN_VIEWED = 'WALLET_CREATE_SCREEN_VIEWED',
  WALLET_CREATE_CTA_CLICKED = 'WALLET_CREATE_CTA_CLICKED',
  WALLET_CREATION_SUBMITTED = 'WALLET_CREATION_SUBMITTED',
  WALLET_CREATION_SUCCESS = 'WALLET_CREATION_SUCCESS',
  WALLET_CREATION_FAILED = 'WALLET_CREATION_FAILED',
  WALLET_CREATION_DOWNLOAD_ERROR= 'WALLET_CREATION_DOWNLOAD_ERROR',
  MONEY_LOAD_SCREEN_VIEWED = 'MONEY_LOAD_SCREEN_VIEWED',
  MONEY_LOAD_CTA_CLICKED = 'MONEY_LOAD_CTA_CLICKED',
  MONEY_LOAD_INITIATED = 'MONEY_LOAD_INITIATED',
  MONEY_LOAD_SUCCESS = 'MONEY_LOAD_SUCCESS',
  MONEY_LOAD_FAILED = 'MONEY_LOAD_FAILED',
  MONEY_LOAD_DOWNLOAD_ERROR = 'MONEY_LOAD_DOWNLOAD_ERROR',
  WALLET_REFUND_INITIATED = 'WALLET_REFUND_INITIATED',
  WALLET_REFUND_REVIEW_SCREEN_VIEWED = 'WALLET_REFUND_REVIEW_SCREEN_VIEWED',
  WALLET_REFUND_SUBMITTED = 'WALLET_REFUND_SUBMITTED',
  WALLET_REFUND_SUCCESS = 'WALLET_REFUND_SUCCESS',
  WALLET_REFUND_FAILED = 'WALLET_REFUND_FAILED',
}

export interface AddRemitterAccountPayloadType {
  accountName: string;
  accountNo: string;
  accountType: string;
  bankName: string;
  ifscCode: string;
  merchantId: string | number;
  status: string;
}

export interface AddCurrentAccountPayloadType {
  sourceSystem: string;
  accountName: string;
  accountNumber: string;
  branchCode: string;
  accountType: string;
  customerId: string;
  integrationType: string;
  status: string;
  bankProvider: string;
}

export interface AddUpiAccountPayloadType {
  sourceSystem: string;
  mode: string;
  bankProvider: string;
  status: string;
  values: {
    key: string;
    value: string;
  }[];
  merchantId: string | number;
}

export interface MerchantDetailsType {
  merchantId: MerchantIdType;
  credentials: {
    secretKey: string;
    mid: MerchantIdType;
    iss: string;
    agr: string;
    srv: string;
    audience: string;
    userReferenceId: string;
    publicKey: string;
  };
}

export interface AddPublicKeyType {
  merchantId: MerchantIdType;
  publicKey: string;
  isAdmin: boolean;
}

export interface ConfigureUpiCredentialsPayloadType {
  deviceID: string;
  mobileNo: string;
  channelCode: string;
  profileId: string;
  mcc: string;
  accountProvider: string;
  payerVa: string;
  merchantId: MerchantIdType;
}

export interface ConfigureIMPSCredentialsPayloadType {
  passcode: string;
  BCId: string;
  Rcode: string;
  senderName: string;
  mobile: string;
  AggrId: string;
  merchantId: MerchantIdType;
}

export interface ConfigureNEFTCredentialsPayloadType {
  AggrName: string;
  AggrId: string;
  CorpId: string;
  UserId: string;
  DebitAcc: string;
  merchantId: MerchantIdType;
}

export interface UpdateRemitterAccountPayloadType {
  id: number;
  merchantId: string | number;
  status: string;
}

export interface ActivateCurrentAccountPayloadType {
  accountReferenceId: string | number;
  merchantId: MerchantIdType;
  sourceSystem: string;
}

export interface UpdateCurrentAccountPayloadType {
  accountReferenceId: string;
  properties: Record<string, any>;
}

export interface ActivateUpiAccountPayloadType {
  merchantId: MerchantIdType;
  accountReferenceId: string | number;
}

export interface ActionsReturnType {
  type: string;
  payload: {
    serviceMethod: () => void;
    actionTypeSuccess: string;
    actionTypeFailure: string;
    actionTypeRequest: string;
  };
}

export interface UpdateKycDetailsRequestPayloadType {
  businessName: string;
  businessPan: string;
  merchantId: MerchantIdType;
  contactNumber: string;
  email: string;
  taxInformation: string;
  billingAddress: string;
  kycDocuments: string;
  entityType: string;
  kycStatus: string;
  id: null | string;
}
export type MerchantIdType = string | number;
export type AccountId = string | number;
export type TransactionIdType = string | number;
export type ProgramIdType = string | number;

export interface PayoutCommonBulkFileApproveRejectPayload {
  type: 'BENEFICIARY' | 'PAYOUT';
  apiPayload: {
    checkerAction: 'APPROVE' | 'REJECT';
    merchantId: MerchantIdType;
    recordId: number;
    rejectionReason?: string;
  };
}

export type StringObjectType = {
  [key: string]: string;
};

export type BooleanObjectType = {
  [key: string]: boolean;
};
export enum EnumTransactionStatus {
  CHARGED = 4,
  REFUNDED = 6,
  PARTIALLY_REFUNDED = 9,
}
export enum EnumGateway {
  EDGE = 'Edge',
  PAYU = 'Payu',
  RAZOR_PAY = 'RazorPay',
  CCAVENUE = 'CCAVENUE',
}
export enum EnumPaymentMode {
  CREDIT_DEBIT = 'CREDIT/DEBIT CARD',
  NETBANKING = 'NET BANKING',
  EMI = 'EMI',
  UPI = 'UPI',
  WALLET = 'WALLET',
  DEBIT_EMI = 'DEBIT EMI',
  BRAND_WALLET = 'BRAND WALLET'
}
export enum EnumProgramType {
  MULTICART_BRAND_EMI = 112,
  SINGLE_CART_BRAND_EMI = 106,
  BANK_EMI = 105,
}

export type FeatureIdWithMID = {
  merchantId: MerchantIdType;
  id: MerchantIdType;
};

export enum EnumProduct {
  edge = 'EDGE',
  plural = 'ROUTER',
  payout = 'PAYOUT',
  subscription = 'SUBSCRIPTIONS',
}
